// import queryString from "query-string";
import React, { useContext } from "react";
import {
  CustomButton2,
  CustomDropdownFilter,
  CustomDropdownSearch,
  //   CustomRadioButtonGroup,
  //   DropDownSearchCities,
  //   DropDownSearchProvinces,
  //   DropDownSearchSuperAgent,
} from "../../../../components";
import Cookies from "js-cookie";
import constants from "../../../../values/constants";
import "./index.scss";
import { useQuery } from "react-query";
import values from "../../../../values";
import api from "../../../../api";
import Context from "../../../../context";
import {
  ICityItem,
  IItem,
  IProvinceItem,
} from "../../../../types/common.interface";
import utils from "../../../../utils";
import { APPROVE_STATUS } from "../../../../values/dropdownItems";
import { useTranslation } from "react-i18next";

const FilterAgent = () => {
  // ============================== Value Validation ================================

  //   const {search} = queryString.parse(window.location.search);
  const [effect, setEffect] = React.useState(false);
  const [selectedFilters] = React.useState<any>({
    // isBlock,
    // isApproved,
    // province,
    // city,
  });

  const { requestCompany, setRequestCompany } = useContext(
    Context.CompanyScreen
  );

  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );

  const getAllSuperAgent = useQuery(
    [values.useQueryKeys.getAllSuperAgent],
    () => api.post.administrator.getAllSuperAgent({}),
    { enabled: userType === "ADMIN" }
  );

  const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
    api.get.common.getAllProvince()
  );
  const getAllCity = useQuery(
    [values.useQueryKeys.getAllCity, requestCompany?.filters?.province],
    () =>
      api.get.common.getAllCity({
        provinceCode: requestCompany?.filters?.province?.Code,
      })
  );

  const AllSuperAgentWithCompleteName = getAllSuperAgent?.data?.result?.map(
    (item: any) => {
      return {
        ...item,
        completeName: item.firstName + " " + item.lastName,
      };
    }
  );

  // ================================ UseEffect Call ===============================

  React.useEffect(() => {
    if (effect) {
      //   utils.urlGenerator({
      //     navigate,
      //     filters: selectedFilters,
      //     searchString: search ? String(search) : null,
      //   });
    } else setEffect(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters]);

  const { t } = useTranslation();

  // ================================== JSX Content ================================
  return (
    <div className="filter-container">
      <CustomDropdownFilter title={t("filter")} hoverTitle={t("filter")}>
        {userType === "ADMIN" && (
          <>
            <p className="filter-labels">{t("municipality")}:</p>
            <CustomDropdownSearch
              items={AllSuperAgentWithCompleteName}
              itemName="completeName"
              defaultItem={requestCompany?.filters?.superAgent}
              onSelectItem={(event: IProvinceItem) =>
                setRequestCompany({
                  ...requestCompany,
                  filters: {
                    ...requestCompany?.filters,
                    superAgent: event,
                  },
                })
              }
              placeHolder={t("selectMunicipality")}
            />
          </>
        )}
        <p className="filter-labels">{t("province")}:</p>
        <CustomDropdownSearch
          items={getAllProvince?.data?.result}
          itemName="Name"
          defaultItem={requestCompany?.filters?.province}
          onSelectItem={(event: IProvinceItem) =>
            setRequestCompany({
              ...requestCompany,
              filters: {
                ...requestCompany?.filters,
                province: event,
                city: undefined,
              },
            })
          }
          placeHolder={t("selectProvince")}
        />
        <p className="filter-labels">{t("city")}:</p>
        <CustomDropdownSearch
          items={getAllCity?.data?.result}
          itemName="CityName"
          defaultItem={requestCompany?.filters?.city}
          onSelectItem={(event: ICityItem) =>
            setRequestCompany({
              ...requestCompany,
              filters: {
                ...requestCompany?.filters,

                city: event,
              },
            })
          }
          placeHolder={t("selectCity")}
        />{" "}
        <p className="filter-labels">{t("approveStatus")}:</p>
        <CustomDropdownSearch
          items={APPROVE_STATUS}
          itemName="name"
          defaultItem={APPROVE_STATUS.find(
            (item) => item.value === requestCompany?.filters?.approved?.value
          )}
          onSelectItem={(event: IItem) =>
            setRequestCompany({
              ...requestCompany,
              filters: {
                ...requestCompany?.filters,
                approved: event,
              },
            })
          }
          placeHolder={t("selectApproveStatus")}
        />
        {/* <CustomRadioButtonGroup
          menus={values.radioButtonItems.rbiIsBlock}
          selected={selectedFilters?.isBlock}
          onClick={(selected: iItem | null) => setSelectedFilters({...selectedFilters, isBlock: selected})}
        /> */}
        <div className="filter-footer">
          <CustomButton2
            title={t("reset")}
            onClick={() => {
              setRequestCompany({
                limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
                page: 1,
              });
            }}
            type="primary"
          />
        </div>
      </CustomDropdownFilter>
    </div>
  );
};

export default FilterAgent;
